import React from 'react';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { LogoContainer } from './AuthContainer.styles';
import logo from '../../../../../assets/logo/square.png';
import Wallpaper from '../../../../../assets/backgrounds/Wallpaper.png';

const AuthContainer = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${Wallpaper})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <LogoContainer>
        <img
          src={logo}
          alt="Tempo Logo"
          style={{ width: '40px', height: '40px', marginRight: '10px' }}
        />
        <Typography variant="h6" color="white">
          Tempo
        </Typography>
      </LogoContainer>
      {children}
    </motion.div>
  );
};

export default AuthContainer;